class Node {
    constructor({ stepId, choiceId = null }) {
        this.stepId = stepId;
        this.choiceId = choiceId;
    }
}

export default Node;
